shadow$provide[333] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Arrow:{enumerable:true, get:function() {
  return Arrow;
}}});
var require$three = require("three");
var require$_DOT__DOT__SLASH_geometry_SLASH_arrowgeometry_DOT_js = require("../geometry/arrowgeometry.js");
var require$_DOT__SLASH_base_DOT_js = require("./base.js");
class Arrow extends require$_DOT__SLASH_base_DOT_js.Base {
  constructor(renderer, shaders, options) {
    let f;
    super(renderer, shaders, options);
    let {uniforms} = options;
    const {material, position, color, mask, map, combine, stpq, linear} = options;
    if (uniforms == null) {
      uniforms = {};
    }
    const hasStyle = uniforms.styleColor != null;
    this.geometry = new require$_DOT__DOT__SLASH_geometry_SLASH_arrowgeometry_DOT_js.ArrowGeometry({sides:options.sides, samples:options.samples, strips:options.strips, ribbons:options.ribbons, layers:options.layers, anchor:options.anchor, flip:options.flip, closed:options.closed,});
    this._adopt(uniforms);
    this._adopt(this.geometry.uniforms);
    const defs = {};
    if (closed) {
      defs["ARROW_CLOSED"] = "";
    }
    const factory = shaders.material();
    const v = factory.vertex;
    v.pipe(this._vertexColor(color, mask));
    v.require(this._vertexPosition(position, material, map, 1, stpq));
    v.pipe("arrow.position", this.uniforms, defs);
    v.pipe("project.position", this.uniforms);
    factory.fragment = f = this._fragmentColor(hasStyle, material, color, mask, map, 1, stpq, combine, linear);
    f.pipe("fragment.color", this.uniforms);
    const opts = factory.link({side:require$three.DoubleSide,});
    this.material = this._material(opts);
    const object = new require$three.Mesh(this.geometry, this.material);
    object.frustumCulled = false;
    object.matrixAutoUpdate = false;
    object.userData = opts;
    this._raw(object);
    this.renders = [object];
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
    this.renders = this.geometry = this.material = null;
    return super.dispose();
  }
}

};